// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$(".privary-navigation__item").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
			console.log("🚀 ~ $ ~ $('ul.submenu',this):", $('ul.submenu',this))
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

		$('#open-nav').click(function() {
			$('#nav').toggleClass('open');
			$(this).toggleClass('open');
		});
	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})

		/*****************************************************
		OBSERVER TO ADD PARALLAX EFFECT
		/*****************************************************/
		var scrollParallax = [];
		var scrolled = 0;

		// screen height
		var v_height =
		window.innerHeight ||
		document.documentElement.clientHeight ||
		document.body.clientHeight;

		function doParallax(elm) {
		let boundes = elm.dataset.parallax.split(","); // get it from html
		//get distance in positive value
		let distance = Math.abs(boundes[0] - boundes[1]);
		if (boundes[0] > boundes[1]) {
			//get distance in negative value (to do the scroll inverse)
			distance = distance * -1;
		}
		//Equivalent distance using screen height + element height
		const unit_scroll = distance / (v_height + elm.offsetHeight);
		let temp = 0;

		let topElement = 0;
		let element = elm;

		let id_elem = elm.dataset.parallaxid;

		do {
			topElement += element.offsetTop || 0;
			element = element.offsetParent;
		} while (element);

		let parallaxFunction = function () {
			//Obtain the distance between top screen and document top 0
			scrolled = document.documentElement.scrollTop || window.pageYOffset;
			//Distance of bottom page to top of the element
			let relative_distance = scrolled + v_height - topElement;
			//transpoling data to move the parallax element relative to the scroll of all the screen
			temp = unit_scroll * relative_distance + parseInt(boundes[0]);
			//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
			elm.setAttribute("style", "transform: translate(0, " + temp + "px)");
		};

		scrollParallax[id_elem] = parallaxFunction;

		window.addEventListener("scroll", scrollParallax[id_elem]);
		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element");

		if (observers_parallax) {
		let options_parallax = {
			root: null, // relative to document viewport
			rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0, // visible amount of item shown in relation to root
		};

		function handler_parallax(entries, observer) {
			let entry;
			entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				doParallax(entry.target);
			} else {
				let id_elem = entry.target.dataset.parallaxid;
				window.removeEventListener("scroll", scrollParallax[id_elem]);
			}
			});
		}

		let observable_parallax = new IntersectionObserver(
			handler_parallax,
			options_parallax
		);
		let counter = 1;
		observers_parallax.forEach(function (element) {
			observable_parallax.observe(element);
			element.dataset.parallaxid = counter;
			counter++;
		});
		}

		//for Menus
		document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.menu__unitmenu').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

		if (i === 0) btn.click();
		});

		

	};

	$('.double-cards__item').hover(
		function() {
			$(this).addClass('hover-class');
		},
		function() {
			$(this).removeClass('hover-class');
		}
	);

	//Add second span on every button for animations
	$('button[type="submit"]').each(function() {
		var spanContent = $(this).find('span').html();
		$(this).append('<span class="second">' + spanContent + '</span>');
	});

	$('.btn').each(function() {
		var spanContent = $(this).find('span').html();
		$(this).append('<span class="second">' + spanContent + '</span>');
	});

	//BTN Animations
	var text = $('.btn span');
	text = [...text]

	text.forEach((text) => {
		var chars = text.textContent.split("");

		text.innerHTML = chars.map(function(char, i) {
			return '<span style="transition-delay:' + (i * 15) + 'ms">' + char + '</span>';
		}).join('');

	});
	//BTN Animations
	var textFooter = $('.signup-btn span');
	textFooter = [...textFooter]

	textFooter.forEach((textFooter) => {
		var chars = textFooter.textContent.split("");

		textFooter.innerHTML = chars.map(function(char, i) {
			return '<span style="transition-delay:' + (i * 15) + 'ms">' + char + '</span>';
		}).join('');

	});

}());
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}